import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { palette } from './palette';
import { fontSizes, typography } from './typography';
import { components } from './components';

export const theme = responsiveFontSizes(
  createTheme({
    palette,
    typography,
    components,
    fontSizes,
  })
);
